import React, { FC, useState } from 'react';
import { Box, Button, Divider, Typography, useTheme } from '@mui/material';
import ReviewWrapper from '../ReviewWrapper';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import { ExpandLess, MoreVert, Person } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import Block from '../../Block/Block';
import ReviewText from '../ReviewText';

interface Props extends IReviewNewProps {}

const AerzteReview: FC<Props> = ({
  commentingModule,
  hideHeader,
  reviewEntry,
  statusModule,
  status,
  deletionModule,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [showAllBlocks, setShowAllBlocks] = useState(false);

  const { username, text, rating, blocks } = reviewEntry.review;

  return (
    <ReviewWrapper
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={true}
      rating={rating}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {username && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Person fontSize="small" />
          <Typography
            variant="body1"
            sx={{ ml: theme.spacing(1) }}
          >
            {username}
          </Typography>
        </Box>
      )}
      <ReviewText text={text} />
      {blocks && blocks.length > 0 && !showAllBlocks && (
        <Box sx={{ mt: theme.spacing(1) }}>
          <Divider orientation="horizontal" />
          <Block
            rating={blocks.filter((value) => typeof value.rating === 'number')[0].rating}
            text={blocks.filter((value) => typeof value.rating === 'number')[0].text}
            title={blocks.filter((value) => typeof value.rating === 'number')[0].title}
          />
          <Button
            variant="outlined"
            size="small"
            startIcon={<MoreVert />}
            onClick={() => setShowAllBlocks(!showAllBlocks)}
            sx={{
              my: theme.spacing(1),
            }}
          >
            {t('show_more')}
          </Button>
        </Box>
      )}
      {blocks && blocks.length > 0 && showAllBlocks && (
        <Box sx={{ mt: theme.spacing(3) }}>
          {blocks
            .filter((value) => typeof value.rating === 'number')
            .map(({ rating, text, title }, index) => {
              return (
                <Box
                  key={`Review_${reviewEntry.id}_Block_${index}`}
                  sx={{ mt: theme.spacing(1) }}
                >
                  <Divider orientation="horizontal" />
                  <Block
                    rating={rating}
                    text={text}
                    title={title}
                  />
                </Box>
              );
            })}
          <Button
            variant="outlined"
            size="small"
            startIcon={<ExpandLess />}
            onClick={() => setShowAllBlocks(!showAllBlocks)}
            sx={{
              mb: theme.spacing(1),
            }}
          >
            {t('show_less')}
          </Button>
        </Box>
      )}
    </ReviewWrapper>
  );
};

export default AerzteReview;
